import Container from '@material-ui/core/Container';
import withStyles from '@material-ui/core/styles/withStyles';
import firebase from 'firebase/app';
import React, { useEffect } from 'react';
import { useLogin, useTranslate } from 'react-admin';
import {
  LoginSuccess,
  PhoneForm,
  usePhoneLoginForm,
  VerificationCodeForm
} from '../../bitComponents/phone-login-form/MimunPhoneLoginForm';
import StepperForm from '../../bitComponents/stepper-form';
import UnauthorizedLogin from '../UnauthorizedLogin';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

export const RECAPTCHA_SITE_KEY =
  process.env.REACT_APP_RECAPTCHA_SITE_KEY ||
  '6LcO_hEqAAAAAH2x-Dm6OwlvUwgVcqfClVi4vzdW';

const styles = (theme) => ({
  formContainer: {
    padding: 0,
    direction: 'rtl'
  },
  loginFormContainer: {
    [theme.breakpoints.up('sm')]: {
      width: 400
    },
    [theme.breakpoints.down('sm')]: {
      width: 330
    }
  }
});

const MimunLoginPageOtp = ({ classes }) => {
  const {
    resendCode,
    submitPhone,
    resendLoading,
    resendError,
    resetPhone,
    setStepIndex,
    sendPhoneVerificationCode,
    phoneSent,
    stepIndex,
    verifyCode
  } = usePhoneLoginForm();

  const login = useLogin();
  const translate = useTranslate();

  const steps = [
    {
      getContent: () => (
        <PhoneForm
          onSubmit={submitPhone}
          sendPhoneVerificationCode={sendPhoneVerificationCode}
          title={translate('ra.auth.sign_in')}
          subtitle={translate('ra.auth.sign_in_subtitle')}
          disableReassuringTip
          disableToggleSignupLogin
        />
      ),
      withoutActions: true
    },
    {
      getContent: () => (
        <VerificationCodeForm
          verifyCode={verifyCode}
          phoneSent={phoneSent}
          onResetPhone={resetPhone}
          onResendCode={resendCode}
          onSubmit={async ({ user }) => {
            try {
              await login({ user });
              setStepIndex(stepIndex + 2);
            } catch (e) {
              setStepIndex(stepIndex + 1);
            }
          }}
          resendLoading={resendLoading}
          resendError={resendError}
        />
      ),
      withoutActions: true
    },
    {
      getContent: () => <UnauthorizedLogin resetPhone={resetPhone} />,
      withoutActions: true
    }
  ];

  return (
    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
      <Container maxWidth="sm" className={classes.formContainer}>
        <div className={classes.loginFormContainer}>
          <StepperForm
            steps={steps}
            withoutActions
            stepIndex={stepIndex}
            handleReset={() => setStepIndex(0)}
            formPreview={<LoginSuccess />}
            withoutReset
            withoutStepsHeader
          />{' '}
        </div>
      </Container>
    </GoogleReCaptchaProvider>
  );
};

export default withStyles(styles)(MimunLoginPageOtp);
